<template>
  <div class="clearfix" v-if="!loader">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="loader" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">       
      </div>
      <div class="d-sm-flex align-items-center">
        <div>
          <div class="select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0">
          </div>
        </div>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table id="" class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('linkValidationLevel2.code') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('linkValidationLevel2.beneficiary') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('linkValidationLevel2.operator') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('linkValidationLevel2.phone') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('linkValidationLevel2.amount') }}
              </th> 
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('linkValidationLevel2.date') }}
              </th>
              <!-- <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                STATUT
              </th> -->
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                {{ $t('linkValidationLevel2.actions') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(transaction) in transactions" :key="transaction.payoutId">
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">                
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ transaction.payoutId}}
                  </div>
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction?.clientId}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.operator?.mnoName}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction?.contact}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ transaction.amount.toLocaleString()}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatDateFr(new Date(transaction.transactionDate))}}
              </td>
              <!-- <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="transaction.paymentStatus==='SUCCEEDED'">SUCCESS</span>
                <span class="badge text-outline-danger" v-if="transaction.paymentStatus==='FAILED'">ECHEC</span>
                <span class="badge  text-outline-info" v-if="transaction.paymentStatus==='PROCESSING'">EN COURS</span>
              </td> -->
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button
                  class="default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
                  type="button"
                  style="background-color: #EB9355;" 
                  data-bs-toggle="modal"
                  data-bs-target="#filterLeadModal" 
                  @click="showScreen('REJECTED','Voulez-vous vraiment annuler ce lien ?',transaction?.payoutId)"  
                  v-if="current_permissions('validate_public_token')"        
                >       
                  <!-- Annuler -->
                  <i class="flaticon-close-1 position-relative ms-5 top-2 fs-15"></i>
                </button>
                &nbsp; &nbsp; &nbsp;
                <button
                  class="default-outline-btn position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
                  type="button"                  
                  style="background-color: #EB9355;" 
                  data-bs-toggle="modal"
                  data-bs-target="#filterLeadModal"       
                  @click="showScreen('VALIDATED','Voulez-vous vraiment valider ce lien ?',transaction?.payoutId)"
                  v-if="current_permissions('validate_public_token')"
                >
                  <!-- Confirmer -->
                  <i class="flaticon-draw-check-mark position-relative ms-5 top-2 fs-15"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div id="transactionsTable">
          <h2 class="text-center" id="title">{{ $t('linkValidationLevel2.listTitle') }}</h2>
          <table id="" class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                  {{ $t('linkValidationLevel2.code') }}
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  {{ $t('linkValidationLevel2.operator') }}
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  {{ $t('linkValidationLevel2.phone') }}
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  {{ $t('linkValidationLevel2.amount') }}
                </th> 
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  {{ $t('linkValidationLevel2.date') }}
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  {{ $t('linkValidationLevel2.status') }}
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(transaction) in transactions" :key="transaction.payoutId">
                <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                      {{ transaction.payoutId}}
                    </div>
                  </div>
                </th>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ transaction.operator?.mnoName}}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ transaction?.contact}}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ transaction.amount.toLocaleString()}}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ formatDateFr(new Date(transaction.transactionDate))}}
                </td>
                <td class="shadow-none lh-1 fw-medium">
                  <span v-if="transaction.paymentStatus==='SUCCEEDED'">{{ $t('linkValidationLevel2.success') }}</span>
                  <span v-if="transaction.paymentStatus==='FAILED'">{{ $t('linkValidationLevel2.failed') }}</span>
                  <span v-if="transaction.paymentStatus==='PROCESSING'">{{ $t('linkValidationLevel2.processing') }}</span>
                  <span v-if="transaction.paymentStatus==='PENDING'">{{ $t('linkValidationLevel2.pending') }}</span>
                  <span v-if="transaction.paymentStatus==='INITIATED'">{{ $t('linkValidationLevel2.initiated') }}</span>
                  <span v-if="transaction.paymentStatus==='SCHEDULED'">{{ $t('linkValidationLevel2.scheduled') }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="total>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
      </div>
    </div>
  </div>
 
  <!-- Modal confirmation -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ $t('linkValidationLevel2.alert') }}</h1>                
          <button type="button" class="btn-close" id="close" data-bs-dismiss="modal" aria-label="Close" @click="cancel()"></button>
        </div>
        <div class="modal-body">
          <div style="">
            <h6 v-if="status=='REJECTED' && errors==''" class="text-red fw-bold mb-0 text-center" style="color: red;">{{ message}}</h6>
            <h6 v-if="status=='VALIDATED' && errors==''" class="text-success fw-bold mb-0 text-center" style="color: red;">{{ message}}</h6>
          </div>
          <div v-if="errors!==''">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">code: {{ errorId}}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>              
          </div>
        </div>
        <div class="modal-footer">                
          <button type="button" class="btn default-outline-btn bg-transparent" style="background-color: #FFF;" data-bs-dismiss="modal" @click="cancel()">
            {{ $t('linkValidationLevel2.no') }}
          </button>               
          <button :disabled="!btnLoad" type="button" class="btn" style="background-color: #EB9355;" @click="storeValidationLink()">           
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('linkValidationLevel2.yes') }}</span> 
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Details -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">     
      <div class="modal-content">
        <form>
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('linkValidationLevel2.transactionDetails') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('linkValidationLevel2.transactionCode') }}</label>              
                  <div>
                    <input v-model="transaction.payoutId" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('linkValidationLevel2.phone') }}</label>              
                  <div>
                    <input v-model="transaction.contact" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('linkValidationLevel2.amount') }}</label>
                  <div>
                    <input v-model="amount" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('linkValidationLevel2.date') }}</label>
                  <div>
                    <input v-model="transaction.transactionDate" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('linkValidationLevel2.operator') }}</label>
                  <div>
                    <input v-model="operator" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('linkValidationLevel2.status') }}</label>
                  <div>
                    <input v-model="paymentStatus" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" readonly />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup  lang="ts">

import {ref, onMounted,onBeforeMount,inject  } from "vue";
import { useRoute} from 'vue-router'
import axios from 'axios';
import flatpickr from "flatpickr";
import html2pdf from "html2pdf.js";
import LeadscontentPdf from "./LeadsContentPdf.vue";
import router from '../../../router/index'
import conf from '../../../../env.json'
import { useI18n } from "vue-i18n";
import {current_permissions} from '../../../utils/permission';
import{showToast,checkSessionValidate} from '../../../utils/function'
import TransactionRepository from '../../../repositories/TransactionRepository'
import { Business,Transaction } from "@/utils/Model";
const backApi=inject('back');
let role: string|null = localStorage.getItem('role');

  declare interface Organization {
  id : string,
  code: string,
  name: string,
  description: string,    
  email: string,
  created_at: string
  }

  declare interface Operator {
  id : string,
  code: string,
  mnoName: string,
  status: string,    
  countryCode: string  
  }
const { t } = useI18n();
const leadPlaceholder = "Select date";


let url = '';
if (role == 'SUPERADMIN' || role == 'BUSINESS' || role == 'SUPPORT') {
  url = backApi + '/secure/transactions/extended';
} else {
  url = backApi + '/secure/transactions';
}

let data = [];
let beginDate = ref('');
let endDate = ref('');
let today = ref('');
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedStatus = ref('');
const loader = ref(false);
const page = ref(1);
const total = ref(0);
//const pageServ = ref('');
const pagesLeft = ref(0);
const currentPage = ref(0);
const numPages = ref(0);
const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const amount = ref(0);
const operator = ref('');
const paymentStatus = ref(''); 
const status = ref(''); 
const message = ref(''); 
const payoutIdLink = ref('');
const btnLoad = ref(true);
const errors = ref('');
const errorId = ref('');

    
const transactions =ref(new Array<Transaction>());
const organizations =ref(new Array<Organization>());
const operators =ref(new Array<Operator>());
let operatorsTemp =new Array<Operator>();
const transaction =ref({} as Transaction);

let transactionId:string|null;
let idType:string|null;

  function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

function formatDateEn(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}

function formatDateEnBis(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}

const cancel = () =>{
  status.value="";
  errorId.value="";
  errors.value="";
  payoutIdLink.value="";
}

function handleOrganizationChange(event) {
      selectedOrganization.value = event.target.value;
    }

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleStatusChange(event) {
  selectedStatus.value = event.target.value;
}

function handleCountryChange(event) {
  
  var j = 0;
  var operatorArr = new Array<Operator>();
  while(j<operatorsTemp.length){    
      if(operatorsTemp[j].countryCode == event.target.value){         
          operatorArr.push(operatorsTemp[j]);
      }      
      j++;
  }
   operators.value = operatorArr;
}
    
let datab ='' ;
onMounted(() => {
  checkSessionValidate(1)
 
   getTransactions();
  setTimeout(function () {
        flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
        enableTime: true,
      });
        },1000);

 

  flatpickr("#basic-calendar", {
    dateFormat: "Y-m-d H:i",
  });

});
const token =  localStorage.getItem('login_token');
const loadTransaction = (code)=>{
  
  axios.get(`${url}/${code}`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        transaction.value = response.data;  
        operator.value=  response.data.operator?.mnoName;
        amount.value= response.data.amount.toLocaleString();
       
         if(response.data.paymentStatus==='SUCCEEDED'){
          paymentStatus.value = "SUCCESS"
         }else if(response.data.paymentStatus==='PROCESSING'){
          paymentStatus.value = "EN COURS"
         }else if(response.data.paymentStatus==='PENDING'){
          paymentStatus.value = "EN ATTENTE"
         }else if(response.data.paymentStatus==='INITIATED'){
          paymentStatus.value = "INITIÉ"
         }else if(response.data.paymentStatus==='SCHEDULED'){
          paymentStatus.value = "PLANIFIÉ"
         }else{
          paymentStatus.value = "ECHEC"
         }   
         
        loader.value=true;
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }   
              
          }
  });
}

const getTransactionsOld = async () =>{
   loader.value=false;
   let data = await TransactionRepository.getRecords({publicTokenValidationStatus:'VALIDATED',validationStatus:'DRAFT'});  
   if(Array.isArray(data.transactions)){    
    transactions.value = data?.transactions;
   }else{
    // alert(data?.error)
   }
   loader.value=true;  
}

const getTransactions = (arg=1) =>{
    loader.value=false;
    gettran.value = true;
    search.value = false;
    search1.value = false;

    axios.get(`${url}?publicTokenValidationStatus=VALIDATED&validationStatus=DRAFT`,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        transactions.value = response.data.data;  
       
        loader.value=true;
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/');
              }   
              
          }
  });

}
const getOrganizations = () =>{

    axios.get(backApi+'/secure/organizations/',{  
      headers: {
           
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {
        // users.value = response.data;
        organizations.value = response.data;         
        console.log(response.data);
        
        
    }).catch((error) => {
          if( error.response){
              console.log(error.response.data);
              if(error.response.status === 401){
                router.push('/')
              }   
              
          }
   });
  //  loader.value=true;
}
const getOperators = () =>{

axios.get(backApi+'/public/operators/',{  //secure
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // users.value = response.data;
    operatorsTemp = response.data;  //.data.users          
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data);
          if(error.response.status === 401){
            router.push('/')
            
          }   
          
      }
});
//  loader.value=true;
}

const exportExcelReport = (labels,fields,filename) =>{
  
  import("../../../utils/Export2Excel").then((excel)=>{
 
    const dataForExcel= formatJSon(fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:labels,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:filename,      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}



const exportExcel = () =>{
  
  import("../../../utils/Export2Excel").then((excel)=>{
    // const data = transactions.value;
    const Header =["CODE TRANSACTION","OPERATEUR","TELEPHONE","MONTANT","DATE","STATUT"];
    const Fields = ["payoutId","operator_name","contact","amount","transactionDate","paymentStatus"];//mnoName
    // console.log(data);
    const dataForExcel= formatJSon(Fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"transactions",      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}


function formatJSon(FilterData,JsonData){
  return JsonData.map((v)=>FilterData.map(j=>{
      return v[j];
    }));
}


//[top, left, bottom, right]
const searchTransaction = (arg=1)=>{
  loader.value=false;
  gettran.value = false;
  search.value = true;
  search1.value = false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }
    const todayE =  formatDateEn(new Date(endDate.value),1);   
  axios.get(`${url}?page=${arg}&dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operator=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        transactions.value = response.data.data; 
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.currentPage);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        
        loader.value=true; 
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/');
              }   
              
          }
  });
}
const searchTransaction1 = (event,arg=1)=>{  
   if(typeof event.target.value!=='undefined'){
    today.value = event.target.value 
   }  
  
    // alert(today.value)  
    loader.value=false;
    gettran.value = false;
    search.value = false;
    search1.value = true;

    const todayE =  formatDateEn(new Date(today.value),1);   
  axios.get(`${url}?page=${arg}&dateD=${today.value}&dateF=${todayE}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transactions.value = response.data.data;  
        // data  = response.data.transactions;  
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.currentPage);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        
        loader.value=true; 
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              }   
              
          }
  });
}

const searchTransactionForExport = ()=>{  
   btnLoad.value=false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }
  // if(selectedOrganization.value===''){
  //   selectedOrganization.value = "" ; 
  // }
    const todayE =  formatDateEn(new Date(endDate.value),1);   
  axios.get(`${backApi}/secure/transactions/list/export?dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operator=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        // transactions.value = response.data.transactions;  //.data.users 
        if(response.status === 200){  
        data  = response.data;  
        // console.log(data)
        
        for (let pas = 0; pas < data.length; pas++) {
          data[pas].operator_name = data[pas].operator?.mnoName;
        }  
        exportExcel()  
        //  console.log(data);
        btnLoad.value=true; 
      }   
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              } else{                
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;               
         
              }  
              
          }
  });
}

const reportForExport = ()=>{  
   btnLoad.value=false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }
  // alert(selectedOrganization.value);
    const todayE =  formatDateEn(new Date(endDate.value),1);   
  axios.post(`${backApi}/secure/organizations/report`,
       {          
         start:beginDate.value,
         end:todayE,
          organization:selectedOrganization.value          
        },
        {
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {        
        if(response.status === 200){  
        data  = response.data.transactions;  
        // const dataTemp  = response.data; 
        console.log(data)
        
        for (let pas = 0; pas < data.length; pas++) {
          // data[pas].operator_name = data[pas].operator.mnoName;
          data[pas].operationType = (data[pas].operationType=="1")?"Payin":"Payout";
          data[pas].balance = parseFloat(data[pas].collectBalance-(data[pas].payoutBalance-data[pas].topupBalance));        
        }  
        
        const Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","BALANCE","STATUT"];
        const Fields = ["payoutId","transactionDate","status","amount","operationType","","paymentStatus"];

        exportExcelReport(Header,Fields,"report"); 
        //  console.log(data);
        btnLoad.value=true; 
      }   
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              } else{                
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;               
         
              }  
              
          }
  });
}

const showScreen = (statut,msg,payoutId)=>{ 
  status.value=statut;
  message.value=msg;
  payoutIdLink.value = payoutId;
}

const storeValidationLink = async()=>{
  loader.value=false;
  const param = {transactionId:payoutIdLink.value,idType:'payoutId',status:status.value }  
  let data = await TransactionRepository.validate_payout_two(param);
  if(data.status === 201){  
          document.getElementById("close").click();
          showToast("Lien validé avec succès","green");
          status.value='';
          payoutIdLink.value='';
          setTimeout(() => {
            router.push('/transferts/validation/two'); 
            }, 3000);          
           
  }
  loader.value=true;


}

</script>
<style scoped>
#title{
 text-decoration: underline;
 margin-bottom: 2%;
}
#transactionsTable{
 display: none; 
 /* visibility: hidden;*/
}
</style>